export const socialNetworks = [
  {
    title: 'twitter',
    file: 'twitter.png'
  },
  {
    title: 'facebook',
    file: 'facebook.png'
  },
  {
    title: 'youtube',
    file: 'youtube.png'
  }
]
